import Image from 'next/legacy/image'
import PropTypes from 'prop-types'

import { Text, Link, MarkdownContainer } from '@components'

import styles from './style.module.css'

function ArticleList({ articles, searchQuery }) {
  return (
    <div>
      {articles.map(
        ({
          title,
          titleSlug,
          content,
          image,
          imageAlt,
          categoriesSubcategories,
        }) => {
          const category = categoriesSubcategories[0].category

          return (
            <div key={titleSlug} className={styles.articleContainer}>
              <span className={styles.articleImage}>
                <Link link={`/blog/${titleSlug}`}>
                  <Image
                    alt={imageAlt}
                    src={image}
                    layout="responsive"
                    height={200}
                    width={320}
                  />
                </Link>
              </span>

              <div className={styles.articleContent}>
                <Text
                  tag="h4"
                  variant="sectionTitle"
                  color="gray"
                  className={styles.articleCategory}
                >
                  <Link link={`/blog?categoryId=${category.id}`}>
                    {category.name.toUpperCase()}
                  </Link>
                </Text>

                <Text
                  tag="h3"
                  variant="articleTitle"
                  className={styles.articleTitle}
                >
                  <Link link={`/blog/${titleSlug}`}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: title.replace(
                          new RegExp(`(${searchQuery})`, 'gi'),
                          '<b>$1</b>'
                        ),
                      }}
                    />
                  </Link>
                </Text>

                <MarkdownContainer
                  content={content}
                  searchQuery={searchQuery}
                  isSmallParagraph
                  parseOnlyFirstParagraph
                />
              </div>
            </div>
          )
        }
      )}
    </div>
  )
}

ArticleList.propTypes = {
  articles: PropTypes.array,
  searchQuery: PropTypes.string,
}

export default ArticleList
